var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"vueDom",attrs:{"id":"app"}},[_c('canvas',{staticClass:"canvas",attrs:{"id":"myCanvas","width":"10","height":"10"}}),_c('router-view'),_c('vizard-captcha')],1)}
var staticRenderFns = []

export { render, staticRenderFns }